import { IsOptional, IsString, MaxLength } from 'class-validator';
import { DEADLINE_REASON_MAX_LENGTH } from './deadline.constants';

export class DeleteDeadlineQueryDto {
  /** Obbligatorio per il soft delete (riga con file o con avvisi già inviati). */
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_REASON_MAX_LENGTH)
  reason?: string;
}
